import axios from 'axios'
// import axios from '../../../utils/axios';

const baseUrl = process.env.REACT_APP_API_URL;
// registerUser user
const registerUser = async (userData) => {
  const path = '/api/user/register_user'
  const url = baseUrl + path
  const response = await axios.post(url, userData)
  return response?.data
}
const validatePageName = async (pageName) => {
  const path = '/api/user/validatePageName'
  const url = baseUrl + path
  const response = await axios.post(url, pageName)
  return response?.data
}


const createUserPassword = async (userDatas) => {
  try {
    const path = '/api/user/registerPassword'
    const url = baseUrl + path

    const response = await axios.post(url, userDatas)
    return response.data
  } catch (error) {
    console.error(error.message)
  }
}


// two factor auth
const twofactorAuth = async (userData) => {
  // const path = '/api/user/';
  // const url = baseUrl + path;
  // const response = await axios.post(url, userData);
  // return response?.data;
}

// loginUser user
const loginUser = async (userData) => {

    const path = '/api/user/login'
    const url = baseUrl + path

    const response = await axios.post(url, userData)

    return response.data
}


// loginUser user
const resetUserPassword = async (userDatas) => {
  try {
    const path = '/api/user/send-reset-password-email'
    const url = baseUrl + path

    const response = await axios.post(url, userDatas)
    return response.data
  } catch (error) {
    console.error(error.message)
  }
}

// logoutUser user
const logoutUser = async () => {
  try {
    const path = '/api/user/logout'
    const url = baseUrl + path

    localStorage.removeItem('user')
    localStorage.removeItem('linkId')
    localStorage.removeItem('linkData')

    const response = await axios.get(url)
    return response.data
  } catch (error) {
    console.error(error.message)
  }
}

const twoFactorAuthentication = async () => {
  try {
    const user = JSON.parse(localStorage.getItem('user')) || ''
    const userID = user?.userid
    const path = `/api/user/twofactorsetup/${userID}`
    const url = baseUrl + path
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    console.error(error.message)
  }
}

const verifyTwoFactor = async (data) => {
  try {
    const path = '/api/user/verify'
    const url = baseUrl + path
    const user = JSON.parse(localStorage.getItem('user')) || ''
    const userID = user?.userid
    const payload = {
      userToken: data,
      userId: userID,
    }

    const response = await axios.post(url, payload)
    return response.data
  } catch (error) {
    console.error(error.message)
  }
}

const contactUs = async (data) => {
  const path = '/api/user/contactUs'
  const url = baseUrl + path

  const payload = {
    firstName: data?.firstName,
    lastName: data?.lastName,
    email: data?.email,
    message: data?.message,
    phoneNumber: data?.phoneNumber,
  }
  const response = await axios.post(url, payload)
  return response.data
}

//  profile picture api call
const updateProfilePic = async (data) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const userId = JSON.parse(localStorage.getItem("user"))?.userid;

  const path = `/api/user/updateProfilePicture`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append("userId", userId|| data.userId);
  bodyFormData.append("picture", data?.picture);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};


const authService = {
  registerUser,
  validatePageName,

  createUserPassword,

  logoutUser,
  loginUser,
  resetUserPassword,

  twofactorAuth,
  twoFactorAuthentication,
  verifyTwoFactor,

  contactUs,

  updateProfilePic,
}
export default authService
